import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLSelectElement> {
  connect(): void {
    super.connect()
    $(this.element).selectpicker()
  }
}
